import { MenuItem } from '@material-ui/core';
import { Autocomplete } from '@material-ui/lab';
import { SupplyCategory } from 'clients/manager/interfaces/supply-categories.interface';
import { supplyCategoriesRequests } from 'clients/manager/supply-categories.requests';
import { TextField } from 'common/components';
import React, { FC, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

interface SelectCategoryProps {
    value: number | undefined | null;
    onChange: (event: React.ChangeEvent<HTMLInputElement>, category: SupplyCategory) => void;
    omitAllOption?: boolean;
}

const SelectCategory: FC<SelectCategoryProps> = ({ value, onChange, omitAllOption }) => {
    const [supplyCategories, setSupplyCategories] = useState<SupplyCategory[]>([]);

    useEffect(() => {
        const request = async () => {
            try {
                const response = await supplyCategoriesRequests.listSupplyCategories();
                setSupplyCategories(response?.data ?? []);
            } catch (error) {}
        };

        request();
    }, []);

    const { t } = useTranslation();

    const allOption: SupplyCategory = {
        id: 0,
        categoryName: t('term.all'),
        dateTimeInsert: new Date(),
        level: 0,
        masterId: 0,
    };

    const options = !omitAllOption ? [allOption, ...supplyCategories] : supplyCategories;

    return (
        <Autocomplete
            size='medium'
            limitTags={10}
            key={`${supplyCategories.length}`}
            fullWidth
            options={options}
            getOptionLabel={(option) => {
                const prefix = option.externalId ? `${option.externalId} - ` : '';
                return `${prefix}${option.categoryName}`;
            }}
            value={supplyCategories.find((category) => category.id === value) ?? null}
            onChange={(_event, selectedCategory) => {
                const event = {
                    ..._event,
                    target: {
                        ..._event.target,
                        name: 'categoryId',
                        value: selectedCategory?.id,
                    },
                } as unknown as React.ChangeEvent<HTMLInputElement>;
                onChange(
                    event,
                    supplyCategories.find(
                        (category) => category.id === Number(event.target.value)
                    ) as SupplyCategory
                );
            }}
            renderInput={(params) => (
                <TextField
                    {...params}
                    id='select'
                    label={t('term.category')}
                    name='categoryId'
                    color='primary'
                    variant='outlined'
                />
            )}
        />
    );
};

export default SelectCategory;
